import React, { useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  IconButton,
  Tooltip,
  Popper,
  MenuList,
  Grow,
  MenuItem,
  Paper,
  ClickAwayListener,
} from '@material-ui/core';

import usePopoverAnchor from 'src/utils/hooks/usePopoverAnchor';
import { ThreeDotsIcon } from 'src/assets/icons/ThreeDotsIcon';
import { ToolbarFormatActions } from './ToolbarFormatActions';
import useStyles from '../useStyles';

export const ToolbarShowMoreActions = ({ buttonFormatsToDisplay }) => {
  const styles = useStyles();
  const ref = useRef();
  const [menuAnchor, openMenu, closeMenu] = usePopoverAnchor();
  const handleClick = (event) => {
    event.preventDefault(); // prevent from editor losing focus
    openMenu(event.currentTarget);
  };

  return (
    <Fragment>
      <Tooltip title={menuAnchor ? '' : 'More'}>
        <IconButton
          className={cx(styles.formatButton, {
            [styles.formatActive]: menuAnchor,
          })}
          ref={ref}
          onMouseDown={handleClick}
        >
          <ThreeDotsIcon />
        </IconButton>
      </Tooltip>
      <Popper
        className={styles.popper}
        anchorEl={menuAnchor}
        open={!!menuAnchor}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: 'left top',
            }}
          >
            <Paper className={styles.paper}>
              <ClickAwayListener
                onClickAway={closeMenu}
                mouseEvent="onMouseDown"
              >
                <MenuList>
                  <ToolbarFormatActions
                    buttonFormatsToDisplay={buttonFormatsToDisplay}
                    wrapperComponent={MenuItem}
                    wrapperProps={{ className: styles.menuItem }}
                    isLabelVisible
                    classes={{
                      label: styles.label,
                      startIcon: styles.startIcon,
                    }}
                  />
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Fragment>
  );
};

ToolbarShowMoreActions.propTypes = {
  buttonFormatsToDisplay: PropTypes.arrayOf(PropTypes.string),
};

ToolbarShowMoreActions.defaultProps = {
  buttonFormatsToDisplay: [],
};
